import { createSlice } from '@reduxjs/toolkit';
// Define the initial state using that type
const initialState = {
    activeTab: 'all',
};
export const tabsSlice = createSlice({
    name: 'tabs',
    initialState,
    reducers: {
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        }
    },
});
// Action creators are generated for each case reducer function
export const { setActiveTab } = tabsSlice.actions;
// Other code such as selectors can use the imported `RootState` type
export const selectActiveTab = (state) => state.tabs.activeTab;
export default tabsSlice.reducer;
